var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialTwitchIconNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 32,
    viewBox: "0 0 27 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 14.8572L20.25 19.4286H15.75L11.8125 23.4286V19.4286H6.75V2.28577H24.75V14.8572Z",
    fill: "#191919"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 0L0 5.71429V26.2857H6.75V32L12.375 26.2857H16.875L27 16V0H5.625ZM24.75 14.8571L20.25 19.4286H15.75L11.8125 23.4286V19.4286H6.75V2.28571H24.75V14.8571Z",
    fill: "#616161"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.375 6.28577H19.125V13.1429H21.375V6.28577Z",
    fill: "#616161"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 6.28577H12.9375V13.1429H15.1875V6.28577Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTwitchIconNew);
export default __webpack_public_path__ + "static/media/social-twitch-icon-new.4bcec3211a9b9e85ec8c7dfdd09ec893.svg";
export { ForwardRef as ReactComponent };